import { useState } from "react";
import { MAX_ACOS_TOOLTIP, MAX_ROAS_TOOLTIP } from "utils/toolTips";
import FormGroupTile from "components/core/basic/FormGroupTile";
import useAdPlanState from "./useAdPlanState";
import withAdPlan from "./withAdPlan";
import { Button } from "../../basic/Button";
import { Checkbox } from "../../../fields/base/Checkbox";
import { VStack, Wrap } from "../../../../../styled-system/jsx";
import { css } from "../../../../../styled-system/css";

const AdPlanNotificationMenu = ({ adId, roas, marketPlace, categoryId, organizationType, onUpdate }) => {
  const { adPlan, onChange, products } = useAdPlanState(
    {},
    marketPlace.marketPlace,
    categoryId,
    adId,
    roas,
    organizationType,
  );
  const [errors, setErrors] = useState([]);

  const onSubmit = async () => {
    if (errors.length > 0) {
      return;
    }
    await onUpdate(adPlan, products);
  };

  return (
    <VStack gap="xlarge">
      <h2 className={css({ margin: 0, fontSize: "xlarge", fontWeight: "bold", color: "text.heading" })}>
        Manage Media Plan Notifications
      </h2>

      <Wrap alignSelf={"stretch"} justify="space-evenly" paddingX="xlarge" alignItems="end">
        <Checkbox
          label="Product Alert"
          value={adPlan.notifications?.productAlertEnabled}
          onChange={() => {
            onChange({
              notifications: {
                ...adPlan.notifications,
                productAlertEnabled: !adPlan.notifications?.productAlertEnabled,
              },
            });
          }}
        />

        <FormGroupTile
          type="formcontrol"
          label={roas ? "Optimal ROAS Range Low" : "Optimal ACOS Range High"}
          formControlType={"number"}
          prefix={"%"}
          prefixSide={"right"}
          toolTip={roas ? MAX_ROAS_TOOLTIP : MAX_ACOS_TOOLTIP}
          stateName={roas ? "minROAS" : "maxACOS"}
          handleChildFormElement={(key, value) => {
            onChange({
              notifications: { ...adPlan.notifications, maxAcos: value },
            });
          }}
          placeholder={`Enter ${roas ? "Min ROAS" : "Max ACoS (%)"}`}
          defaultValue={
            roas ?
              // TODO: figure out how values for ROAS will be passed to backend => do math here when setting state, or just take care of it in serializer/view once passed
              adPlan.notifications.minROAS
            : adPlan?.notifications?.maxAcos
          }
        />

        <FormGroupTile
          type="formcontrol"
          label={"Max Spend"}
          formControlType={"number"}
          toolTip={
            "Enter a limit to the amount spent on an advertised product that, if exceeded, will trigger an alert."
          }
          stateName={"maxSpend"}
          handleChildFormElement={(key, value) => {
            if (!Number.parseInt(value) || Number.parseInt(value) < 0) {
              setErrors([...errors, "Please enter a positive integer."]);
            } else {
              setErrors([]);
            }
            onChange({
              notifications: { ...adPlan.notifications, maxSpend: value },
            });
          }}
          placeholder={`Enter Max Spend`}
          defaultValue={adPlan?.notifications?.maxSpend}
        />
      </Wrap>
      <Button onPress={onSubmit}>Update</Button>
    </VStack>
  );
};

export default withAdPlan(AdPlanNotificationMenu);
